import { render } from "./recoveryMethodDistribution.vue?vue&type=template&id=61d22b94"
import script from "./recoveryMethodDistribution.vue?vue&type=script&lang=js"
export * from "./recoveryMethodDistribution.vue?vue&type=script&lang=js"

import "./recoveryMethodDistribution.vue?vue&type=style&index=0&id=61d22b94&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__